import { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import API from "api/api";
import { useTranslation } from "react-i18next";
import { Colors, MediaQueries, FontWeights } from "@paclife/plds.tokens";

import Card from "common/Card/Card";
import Typography from "common/Typography/Typography";
import titleCase from "utils/formatters/titleCase"
import { Icon } from "@paclife/plds.icon";
import Button from "common/Button/Button";
import Loading from "common/Loading/Loading";

import { AppContext } from "context/AppContext";
import { useTeamContext } from "pages/MyTeam/MyTeam";


const Text = styled(Typography)`
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.Invited {
        color: ${Colors.primary};
    }
    &.assisting {
        font-weight: ${FontWeights[700]};   
    }
    svg {
        margin: auto;
    }
`;

const Grid = styled.div`
    width: 100%;
    margin-bottom: 12px;
    display: grid;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    @media (min-width: ${MediaQueries.md}) {
        grid-template-columns: 2.0fr 2.5fr 1.5fr;
    }
    @media (min-width: ${MediaQueries.lg}) {
        grid-template-columns: 2.0fr 2.5fr 1.5fr 20px;
    }
`;

const RowHeader = styled(Grid)`
    border-bottom: 1px solid ${Colors.neutral800};
`;

const Row = styled(Grid)`
    border-bottom: 1px solid ${Colors.neutral200};
`;

const MemberTools = styled.div`
    width: 100%;
    text-align: center;
`;

const BookOfBusiness = styled(Icon)`
     width: 22px;
     cursor: pointer;
`;

const ReturnLinkWrap = styled.div`
    float: right;
    clear: none;
    position: relative;
    top: -44px;
    a {
        font-size: 1.10rem;
        font-weight: 600;
    }
`;


const DISPLAY_FIELDS = [
    { label: "Name", name: "name" },
    { label: "Email", name: "emailAddress" },
    { label: "Select Team Member to Support ", name: "bofb" }
];


const AssistAdvisor = () => {
    const { t } = useTranslation("manMyTeamAssistant");
    const {
        user,
        userSession
    } = useContext(AppContext);
    const {
        membership
    } = useTeamContext();

    const [mobileView, setMobileView] = useState(false);
    const [memberDisplay, setMemberDisplay] = useState(false);
    const [displayRetBtn, setDisplayRetBtn] = useState(false); 
    const [loading, setLoading] = useState(false);
    const assistUrl = "/profile/team/manage/agentSysId/";
    const agentSysGen = userSession.data?.user?.agentSysGenId;;
    

    useEffect(() => {
        function updateView() {
            if (window.innerWidth <= parseInt(MediaQueries.md)) {
                setMobileView(true);
            } else {
                setMobileView(false);
            }
        }
        window.addEventListener("resize", updateView);
        updateView();
        return () => window.removeEventListener("resize", updateView);
    }, []);

    useEffect(() => {
        if (membership.length > 0) {
            setMemberDisplay(true);     
        }
    }, [membership]);

    useEffect(() => {
        const userType = user.custom?.type;
        const isAssisting = agentSysGen !== '0';

        if (userType === 'A' && isAssisting) {
            setDisplayRetBtn(true)
        } else {
            setDisplayRetBtn(false)
        }
    }, [user, userSession]);

    const assistTeamMember = async (msysid) => {
        setLoading(true);
        try {
            const { succeed } = await API.getAssistApproval(`${assistUrl}${msysid}`);
            const hst = window.location.hostname;
            if (succeed) {
                window.location.href = `https://${hst}/home/dashboard`;
            } else { 
                console.log("Assist team memeber failed!");
                return false;
            }
        } catch (err) {
            console.error("Error from assistTeamMember", err);
        }
        setLoading(false);
    };

    const membershipTools = (memSysId) => {
        return (
            <MemberTools onClick={() => assistTeamMember(memSysId)}
                data-track="analytics"
                data-bname="bookofbusiness"
                title="Assist Advisor"
            >
                 <BookOfBusiness 
                    name="bookOfBusiness" 
                    color={Colors.blue600}
                />
            </MemberTools>
        )
    }

    return (
        <>
            { loading && ( <Loading /> ) }
            { memberDisplay && 
                <Card title={t("membership.title")}>
                   { displayRetBtn && (
                            <ReturnLinkWrap>
                                <Button
                                    variant="primary"
                                    data-track="analytics"
                                    data-bname={"return"}
                                    onClick={() => assistTeamMember('0')}
                                >
                                    {t("membership.button.myBofB")}
                                </Button>
                            </ReturnLinkWrap>
                        )
                    }
                    <div>
                        {!mobileView && (
                            <RowHeader>
                                {DISPLAY_FIELDS.map((field) => (
                                    <Text key={field.label} variant="caption">
                                        {field.label}
                                    </Text>
                                ))}
                            </RowHeader>
                        )}
                        {( membership.map((member, index) => (
                                <Row key={index}>
                                    {DISPLAY_FIELDS.map((field) => (
                                        <Text
                                            variant="body"
                                            className={parseInt(agentSysGen) === parseInt(member['id']) 
                                                        ? "assisting" 
                                                        : member[field.name]
                                            }
                                        >
                                            { mobileView && member[field.name] !== undefined
                                                ? `${field.label}: ${
                                                    member[field.name] || "-"
                                                }`
                                                : titleCase(member[field.name]) || 
                                                    membershipTools(member['id'])
                                            }
                                        </Text>
                                    ))}
                                </Row>
                            ))
                        )}
                    </div>
                </Card>
            } 
        </>
    );
};

export default AssistAdvisor;